import React from "react";
import Header from "../../components/landingPage/Header";
import InputField from "../../components/b2b/InputField";
import { faEnvelope } from "@fortawesome/fontawesome-free-solid";
import Footer from "../../components/landingPage/Footer";
import axios from "axios";
import { toast } from "react-toastify";

const ForgotPassword = () => {
  const [email, setEmail] = React.useState("");

  const sendEmail = async () => {
    toast.loading("Sending email...");
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/user/forgotPassword`,
      { userName: email }
    );

    if (response.data.success) {
      toast.dismiss();
      toast.success(
        "Email sent successfully. Check your mail for further process."
      );
    } else {
      alert("Email not found");
    }
  };
  return (
    <div>
      <Header className="static" />
      <div>
        <img
          src={require("../../assets/images/login_landing.jpg")}
          alt=""
          className="hidden sm:block w-screen h-[26rem] md:h-[24rem] lg:h-[36rem] xl:h-[42rem] object-cover"
        />
        <div className="bg-black sm:transparent sm:hidden w-screen h-96 object-cover"></div>
        <div className="bg-gradient-to-r from-[#121518] to-[#322d2d] w-full h-[22rem] sm:h-[26rem] md:h-[24rem] lg:h-[36rem] xl:h-[42rem] opacity-80 absolute top-0"></div>

        <div className="h-full opacity-100 w-full pt-3 absolute px-5 transform -translate-y-72 sm:-translate-y-[340px] md:-translate-y-[300px] lg:-translate-y-[450px] xl:-translate-y-[550px]">
          <div className="mt-10 text-3xl font-semibold text-center text-white pb-6 sm:pb-14">
            Forgot Password?
          </div>
          <div className="flex-col space-y-4  justify-center items-center">
            {/* <p className="text-center">Enter email</p> */}
            <div className="flex-wrap mx-auto space-y-3 w-80 sm:w-96">
              <InputField
                isFontawesome={true}
                fontawesomeIcon={faEnvelope}
                placeholder="Email address"
                name="email"
                type="email"
                onChange={(e) => {
                  setEmail(e.target.value);
                }}
              />
              <div
                onClick={sendEmail}
                // className="bg-secondary text-white px-2 py-1 rounded-sm cursor-pointer w-min mx-auto"
                className="text-white text-center uppercase bg-secondary hover:bg-gray-700 cursor-pointer w-full font-normal py-1.5 rounded-sm mt-10"
              >
                Send
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ForgotPassword;
